var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22L11.8173 21.9984L11.601 21.9914C6.27147 21.7822 2 17.3805 2 12C2 6.486 6.486 2 12 2ZM12 4C7.589 4 4 7.589 4 12C4 15.8982 6.80309 19.1545 10.4994 19.8589L10.4996 14.7711H8V12.1932H10.5002V9.81385C10.5002 7.41385 11.8728 6 13.9468 6C14.6483 6 15.3825 6.11951 15.7537 6.18981L16 6.23985V8.83923L14.3307 8.83846C13.2594 8.83846 13.0155 9.35955 12.9938 10.1076L12.9921 12.1931H15.8821L15.474 14.7709H12.9921L12.9925 19.9387C16.937 19.4484 20 16.075 20 12C20 7.589 16.411 4 12 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c1661406.svg";
export { ForwardRef as ReactComponent };